export const ACCESS_TOKEN = 'access_token';
export const ACCESS_COOKIE_NAME = 'X-Authorization';
export const REFRESH_TOKEN = 'refresh_token';
export const TOKENS_EXPIRY_ERROR = 'All tokens expired';
export const TOKENS_INVALID_ERROR = 'Tokens are invalid';
export const REFRESH_ROUTE = '/token/access/';
export const LOGIN_ROUTE = '/token/both/';
export const PUBLIC_LOGIN_ROUTE = '/public-login/';

export const CORRELATION_ID = 'correlation_id';

export const STANDALONE_PBE_LOGIN_PARAM = 'pbe-login';
export const PBE_EXTENSION_IDS = [
  'hgopfdjbipnkmnghodbkdjeiekefkigc', // prod
  'apdekgckdmldjjbclogbkokcaahjngjj', // beta
  // 'YOUR_LOCAL_DEV_EXTENSION_ID', // local
];

export const DASH = '—';
